export default "__VITE_ASSET__BVVD2elK__"